export default __webpack_public_path__ + "static/media/stone_juvenile_jade.19e72a62.png";